import { render } from "./DataConsistency.vue?vue&type=template&id=4f687130"
import script from "./DataConsistency.vue?vue&type=script&lang=js"
export * from "./DataConsistency.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__